import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import DeploymentTable from './DeploymentTable';

const SoftwareDeployment = () => {
  const [activeTab, setActiveTab] = useState<'Installed Software' | 'Software Deployment'>('Software Deployment');
  const navigate = useNavigate();

  const assetNavigation = () => {
    navigate('/SoftwareAssets');
  };

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#000)] flex-1">
        <Header title="Software Deployment" dropdown={2} />

        <Card className="flex-1 h-full" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
            {['Installed Software', 'Software Deployment']?.map((tab) => (
              <button
                key={tab}
                onClick={() => {
                  setActiveTab(tab as 'Installed Software' | 'Software Deployment');
                  if (tab === 'Installed Software') {
                    assetNavigation();
                  }
                }}
                style={{
                  padding: '0.5rem 1rem',
                  borderRadius: '6px',
                  borderRight: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                  borderLeft: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                  color: '#fff',
                  cursor: 'pointer',
                }}
              >
                {tab}
              </button>
            ))}
          </div>
          <DeploymentTable />
        </Card>
      </div>
    </div>
  );
};

export default SoftwareDeployment;
